import React from "react";
import DataboxTitleWithInfo from "../../misc/databoxTitleWithInfo";

export default function CardTitle({
  title,
  methodology,
  hideWhenSmall,
  language,
}) {
  return (
    <DataboxTitleWithInfo
      language={language}
      title={title}
      metodologia={methodology}
    />
  );
}
